const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");

const OpsUser = require("../core/vault/OpsUser");
const PlayCopy = require("../office/data/SupportPlayCopy");
const AccountsCopy = require("../office/data/SupportAccountsCopy");
const ReportsCopy = require("../office/data/SupportReportsCopy");
const RosteringCopy = require("../office/data/SupportRosteringCopy");
const PlanningCopy = require("../office/data/SupportPlanningCopy");
const GetStartedCopy = require("../office/data/SupportGetStartedCopy");
const SupportView = require("../office/SupportView");

const TABS = [
	"getStarted",
	"play",
	"reports",
	"accounts",
	"rostering",
	"planning",
];

module.exports = createReactClass({
	displayName: "TeacherSupport",

	propTypes: {
		tab: PT.oneOf(TABS),
		topic: PT.string,
		setNextScrollTo: PT.func.isRequired,
		user: PT.object,
	},

	getTabList: function() {
		let tabs = _.clone(TABS);
		// Filtering out rostering tab here instead of adding so we can verify the incoming
		// tab prop is one of acceptable values
		const tabsToFilter = [];
		if (!OpsUser.hasRosteringTab(this.props.user)) {
			tabsToFilter.push("rostering");
		}
		if (!OpsUser.isTeacher(this.props.user)) {
			tabsToFilter.push("getStarted");
		}
		tabs = _.filter(tabs, t => !_.includes(tabsToFilter, t));
		return tabs;
	},

	render: function() {
		const isSingleSchool = _.clone(
			_.get(this.props.user, ["model", "staffRoles", "isSingleSchool"], false)
		);
		const rosteringCopyFunc = s => {
			return RosteringCopy.getCopy(s, isSingleSchool);
		};
		const tabMap = {
			play: {displayName: "Play", copyFunc: PlayCopy.getCopy},
			reports: {displayName: "Reports", copyFunc: ReportsCopy.getCopy},
			accounts: {displayName: "Accounts", copyFunc: AccountsCopy.getCopy},
			rostering: {displayName: "Rostering", copyFunc: rosteringCopyFunc},
			planning: {displayName: "Planning", copyFunc: PlanningCopy.getCopy},
			getStarted: {
				displayName: "Get Started",
				copyFunc: GetStartedCopy.getTeacherCopy,
			},
		};

		return (
			<SupportView
				supportType={"teacher"}
				tab={this.props.tab || "play"}
				tabList={this.getTabList()}
				tabMap={tabMap}
				topic={this.props.topic}
				setNextScrollTo={this.props.setNextScrollTo}
				useMinTabWidth={true}
			/>
		);
	},
});
